import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { PUBLIC_ROOT } from 'portal-modules/common/constants/urls'
import { connect } from 'react-redux'

export const AuthRoute = ({ authenticated, ...rest }) =>
  authenticated ? <Route {...rest} /> : <Redirect to={PUBLIC_ROOT} />

AuthRoute.propTypes = {
  authenticated: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
}

export default connect(({ user }) => ({ authenticated: !!user.token }))(
  AuthRoute,
)
